import React from 'react';
import styles from './SelectInput.module.css';

export interface SelectOption {
  value: string | number;
  label: string;
}

export interface SelectInputProps {
  id?: string;
  value: string | number;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  options: Array<SelectOption>;
  disabled?: boolean;
  className?: string;
  name?: string;
  placeholderOption?: string;
  style?: React.CSSProperties; // Aggiunta la prop style
}

export const SelectInput: React.FC<SelectInputProps> = ({
  id,
  value,
  onChange,
  options,
  disabled,
  className,
  name,
  placeholderOption,
  style, // Destrutturata la prop style
}) => {
  const selectClasses = `${styles.selectInput} ${className || ''}`;

  return (
    <select
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={selectClasses}
      style={style} // Applicata la prop style
    >
      {placeholderOption && (
        <option value="" disabled>
          {placeholderOption}
        </option>
      )}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};